var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6893 8.68435C19.6893 8.89786 19.6893 9.00461 19.6893 9.21811C19.6893 14.2354 15.9615 20 9.14497 20C7.1213 20 5.09763 19.4662 3.5 18.292C3.81953 18.292 4.13905 18.3987 4.35207 18.3987C6.05621 18.3987 7.65385 17.865 8.93195 16.7975C7.33432 16.7975 5.9497 15.7299 5.41716 14.1287C5.9497 14.1287 6.58876 14.1287 7.1213 13.9152C5.41716 13.5949 4.13905 11.9936 4.13905 10.2856C4.6716 10.6059 5.20414 10.7126 5.8432 10.7126C4.24556 9.64512 3.71302 7.40334 4.6716 5.69531C6.58876 8.04385 9.35799 9.43161 12.3402 9.53836C12.0207 8.25735 12.4467 6.86958 13.4053 6.01557C14.8964 4.6278 17.2396 4.6278 18.6243 6.22907C19.4763 6.01557 20.2219 5.80207 20.9675 5.26831C20.6479 6.12232 20.1154 6.86958 19.3698 7.40334C20.1154 7.29659 20.8609 7.08308 21.5 6.76283C20.9675 7.51009 20.3284 8.1506 19.6893 8.68435Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7c52edddf2f1ae541d0af97cb98f6af6.svg";
export { ForwardRef as ReactComponent };